"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageCard = void 0;
const react_1 = __importDefault(require("react"));
const sds_1 = require("@squiz/sds");
const ImageCard = ({ title, imageUrl, imageType, isSelected, isLoading, onToggleSelection }) => {
    return (react_1.default.createElement("button", { className: `image-card ${isSelected ? 'image-card--selected' : ''} ${isLoading ? 'image-card--loading' : ''}`, onClick: onToggleSelection, "aria-label": isSelected ? 'Deselect image' : 'Select image', "aria-busy": isLoading },
        react_1.default.createElement("div", { className: "image-card__img-container" }, imageUrl && react_1.default.createElement("img", { src: imageUrl, alt: title })),
        react_1.default.createElement("div", { className: "image-card__info" },
            react_1.default.createElement(sds_1.SdsText, { fontSize: sds_1.SdsTextSize.Medium, fontWeight: sds_1.SdsTextWeight.Semibold, text: title, classes: 'image-card__title', customTag: 'div' }),
            react_1.default.createElement("div", { className: "image-card__details" },
                react_1.default.createElement(sds_1.SdsText, { fontSize: sds_1.SdsTextSize.Small, fontWeight: sds_1.SdsTextWeight.Regular, text: imageType, classes: 'image-card__type', customTag: 'div' }),
                isSelected && react_1.default.createElement(sds_1.SdsIcon, { svg: sds_1.ICON_CHECK, classes: 'image-card__checkmark' })))));
};
exports.ImageCard = ImageCard;
exports.default = exports.ImageCard;
